import React from 'react';
import PropTypes from 'prop-types';
import useCountUp from '../../hooks/useCountUp.js';
import {formatCurrency} from '../../utils/formatCurrency.js';

const AnimatedMoney = ({target, currency, duration, compact, animate = true, showDecimals = true}) => {
  const animated = useCountUp(target ?? 0, duration);
  const value = animate ? animated : (target ?? 0);
  return <>{formatCurrency(Math.round(value), currency, compact, showDecimals)}</>;
};

AnimatedMoney.propTypes = {
  target: PropTypes.number,
  currency: PropTypes.string,
  duration: PropTypes.number,
  compact: PropTypes.bool,
  animate: PropTypes.bool,
  showDecimals: PropTypes.bool,
};

export default AnimatedMoney;
